// extracted by mini-css-extract-plugin
module.exports = {"container":"SheetPricesHistory_container__VahY2","icon":"SheetPricesHistory_icon__SwgNH"};